import React  from 'react'
import ColButton from '../../../Elements/ColButton';
import PanelBorder from '../../../Elements/PanelBorder';
import EvaluatorService from '../../../Services/EvaluatorService';

import { saveAs } from 'file-saver';
import LoadingIcon from '../../../Elements/LoadingIcon';
import ErrorMessage from '../../../Elements/ErrorMessage';

class TipaltiExportPanel extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        this.state = {
            loading:false,
            fileDownloaded:false
        };
    }

    componentDidMount() 
    {
        
    }
    
    clickOnSubmitButton ()
    {
        this.setState({loading:true});
        EvaluatorService.GetTipaltiExportFile()
        .then(res =>
        {
            this.setState({loading:false, fileDownloaded:true});
            saveAs(res, 'tipalti_export.csv')
        })
        .catch(() => ErrorMessage.SetErrorMessage("TEP42"));
    }

    render()
    {
        return (
            <PanelBorder
                headerText="Tipalti Export"
                clickOnCancel={this.props.clickOnCancel}
                icon="fa-solid fa-file-csv"
            >
                <form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        this.clickOnSubmitButton();
                    }}
                >
                    <div className="container-fluid"> 
                        <div className="row mb-1">
                            <div className="col lead border rounded p-1">
                                <p>1. Download here the CSV file of the evaluators' data. </p>
                            </div>
                        </div>
                        
                       <LoadingIcon loading={this.state.loading}/>
                        
                        <div className="row">
                            <ColButton 
                                text="Generate the shopper data file" 
                                type="submit" 
                                icon={"fa-solid fa-file-csv"+(this.state.loading?" fa-spin":"")}
                                disabled={this.state.loading}
                                roleKey="tipaltidownloadbutton"
                            />
                        </div>

                        {
                            this.state.fileDownloaded
                            ?
                                <div className="row mb-1 mt-1">
                                    <div className="col lead border rounded p-1">
                                        <p>2. You have to upload the file to the sytem of Tipalti on the following site:</p>
                                        <p>
                                            <a  
                                                href="https://aphub2.sandbox.tipalti.com/#/dashboard/administration/importCenter" 
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >Tipalti ImportCenter</a></p>
                                        
                                    </div>
                                </div>
                            :   null
                        }

                    </div> 
                </form>
            </PanelBorder>
        );
    }
}


export default TipaltiExportPanel;
